<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <mwp-table [tableColumns]="dependentColumns" [dataSource]="dependentMatTableData" (emitButtonSelection)="openUploadDialog($event)" (emitButtonSelection2)="openStatusDialog($event)" header="Dependents" />
</div>